import { EventRequest } from './api';
import TrackingHelpers from './helpers';

class TrackingService {
  private static readonly authToken = '99714fd8-3db5-4c85-8fe1-64eb0e5dbfa1';
  private static readonly baseURL = 'https://trc.node33.ai/';
  private static readonly headers = {
    'X-Authorization': this.authToken,
    'Content-Type': 'application/json',
  };

  public static trackEvent(
    trackingProject: string | undefined,
    eventName: string,
    additionalData: object = {},
  ): void {
    const fullUrl = window.location.href;
    const { custom_order_auid } = TrackingHelpers.getAppUtms();

    const baseAdditionalData = this.buildAdditionalData();
    const body: EventRequest = {
      url: fullUrl,
      project: trackingProject ?? '',
      event: eventName,
      auid: custom_order_auid || '',
      additional_data: {
        ...baseAdditionalData,
        ...additionalData,
      },
    };

    if (navigator.sendBeacon) {
      const data = JSON.stringify(body);
      navigator.sendBeacon(`${this.baseURL}tracking/event`, data);
    } else {
      fetch(`${this.baseURL}tracking/event`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: this.headers,
        mode: 'no-cors',
        credentials: 'omit',
      }).catch(() => {
        // Silently fail
      });
    }
  }

  private static buildAdditionalData() {
    const browserInfo = TrackingHelpers.getBrowserInfo();
    const deviceInfo = TrackingHelpers.getScreenSize();
    const additionalParameters = TrackingHelpers.getAllUrlParameters();
    const cookies = document.cookie
      .split(';')
      .reduce((acc: Record<string, string>, cookie) => {
        const [key, value] = cookie.trim().split('=');
        acc[key] = value;
        return acc;
      }, {});

    const additionalData = {
      ...browserInfo,
      ...deviceInfo,
      ...additionalParameters,
      cookies,
    };

    return additionalData;
  }
}

export default TrackingService;
